import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { EVENT_ICONS, iconDef, METRIC_ICONS } from "@/lib/icons";
import { cn } from "@/lib/utils";

/** A node's icon (Font Awesome). Colour comes from the surrounding text unless set. */
export function NodeIcon({ node, className }: { node: { icon?: string; kind: "event" | "metric" }; className?: string }) {
	return <FontAwesomeIcon icon={iconDef(node.icon, node.kind)} className={cn("w-[1.1em] shrink-0 opacity-75", className)} aria-hidden />;
}

export function IconPicker({ value, onChange, kind }: { value: string; onChange: (v: string) => void; kind: "event" | "metric" }) {
	const names = kind === "event" ? EVENT_ICONS : METRIC_ICONS;
	const list = names.includes(value) ? names : [value, ...names];
	return (
		<Select value={value} onValueChange={onChange}>
			<SelectTrigger className="w-16" aria-label="Icon">
				<SelectValue>
					<NodeIcon node={{ icon: value, kind }} className="opacity-100" />
				</SelectValue>
			</SelectTrigger>
			<SelectContent className="max-h-72">
				<div className="grid grid-cols-6 gap-0.5 p-1">
					{list.map((n) => (
						<SelectItem key={n} value={n} className="justify-center py-1.5 pr-0 pl-0 [&>span:first-child]:hidden" title={n.replace(/-/g, " ")}>
							<NodeIcon node={{ icon: n, kind }} className="opacity-100" />
						</SelectItem>
					))}
				</div>
			</SelectContent>
		</Select>
	);
}
